import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsListPage.ReportsListToolbar', {
    buttonNewReport: 'New Report',

    sortingLabel: 'Sort by:',
    sortByReportNameText: 'Report name',
    sortByRecentText: 'Recent',
    sortByCreationDateText: 'Report creation date',
});
